import { Paper, Typography } from "@mui/material";

export default function ItemAttributeCard({
  label,
  price,
  selected,
  disabled,
  onClick,
}) {
  return (
    <Paper
      onClick={!disabled ? onClick : undefined}
      sx={{
        p: 2,
        borderRadius: 2,
        textAlign: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        border: "1px solid",
        borderColor: selected
          ? "primary.main"
          : disabled
          ? "grey.300"
          : "divider",
        bgcolor: selected
          ? "primary.lighter"
          : disabled
          ? "grey.100"
          : "transparent",
        opacity: disabled && !selected ? 0.4 : 1,
        pointerEvents: disabled && !selected ? "none" : "auto",
        transition: "all 0.2s",
        color: "#000",
        minWidth: 80,
      }}
    >
      <Typography fontWeight={selected ? "bold" : "normal"}>{label}</Typography>
      {price !== undefined && (
        <Typography variant="body2" color="#000">
          ₹{price}
        </Typography>
      )}
    </Paper>
  );
}
